import { LazyBreadcrumb } from '@europrocurement/flexy-components';
import React from 'react';
import { Box, Card, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { DOCUMENT_TYPE_LIST } from '../../constants/paths';
import DocumentTypeForm from './DocumentTypeForm';
import useDocumentTypeFormHandler from '../../hooks/useDocumentTypeFormHandler';

const DocumentTypeAdd: React.FunctionComponent = function () {
    const navigate = useNavigate();
    const { handleCreateForm, requestState } = useDocumentTypeFormHandler();

    const onSubmit = (formData: { [key: string]: unknown }) => {
        handleCreateForm(formData).then((result) => {
            const documentTypeId = result.data?.id;
            if (documentTypeId) {
                navigate(`${DOCUMENT_TYPE_LIST}/${documentTypeId}`);
            }
        });
    };

    const onCancel = () => {
        navigate(DOCUMENT_TYPE_LIST);
    };

    return (
        <>
            <LazyBreadcrumb
                path={[
                    { path: 'Types de documents', link: DOCUMENT_TYPE_LIST },
                    'Nouveau type de document',
                    "Création d'un type de document",
                ]}
            />
            <Box>
                <Grid
                    container
                    spacing={2}
                >
                    <Grid
                        item
                        xs={12}
                        lg={6}
                    >
                        <Card>
                            <DocumentTypeForm
                                onSubmit={onSubmit}
                                onCancel={onCancel}
                                isFormProcessing={requestState.isProcessing}
                            />
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

export default React.memo(DocumentTypeAdd);
